// src/components/Pagination.js
import { useEffect } from 'react';
import ReactPaginate from 'react-paginate';

const Pagination = ({
  page,
  pageSize,
  totalPages,
  handlePageSizeChange,
  isPageSizeDisabled,
  handlePageClick
}) => {
  // Determine if forcePage should be used
  const isPageValid = page >= 0 && page < totalPages;
  const forcePage = isPageValid ? page : totalPages > 0 ? totalPages - 1 : undefined;

useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll smoothly to top
  }, [page]); // Whenever page state changes
  return (
    <div className="pagination-container d-flex justify-content-end align-items-center">
      <div className="page-size-select me-3">
        <label htmlFor="pageSize">Show Entries:</label>
        <select
          id="pageSize"
          onChange={handlePageSizeChange}
          value={pageSize}
          disabled={isPageSizeDisabled}
        >
          <option value="20">20</option>
          <option value="40">40</option>
          <option value="60">60</option>
        </select>
      </div>
      <ReactPaginate
        previousLabel={"Previous"}
        nextLabel={"Next"}
        breakLabel="..."
        breakClassName="break-me"
        pageCount={totalPages}
        marginPagesDisplayed={1}
        pageRangeDisplayed={2}
        onPageChange={handlePageClick}
        activeClassName="active"
        containerClassName="pagination"
        subContainerClassName="pages pagination"
        forcePage={forcePage}
      />
    </div>
  );
};

export default Pagination;
